const hasLowerCase = (str) => /[a-z]/.test(str);
export default hasLowerCase;
